import {Field, FIELD_TYPES, Model} from '../../vue-ocom/schema';

export default Model('job_product', {
  verbose_name: "Job Product",
  verbose_name_plural: "Job Products",
  fields: [
    Field('id', {label: 'ID', primary_key: true, readonly: true, hide: false, field_type: FIELD_TYPES.AutoNumber}),

    Field('product', {
      label: "Product",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeProduct", ref_display_field: "description",
      default: () => {
        return null;
      }
    }),
    Field('ordered_quantity', {
      label: "Ordered Quantity",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return null;
      }
    }),
  ]
});
